module.exports = __webpack_public_path__ + "static/media/listeningWitnessLogo.c921b6af.webp";